import $ from "jquery";
import videojs from "video.js";
import Storage from "@bd-utils/storage";
import GameLogic from "@bd-core/game-logic";

export default class RoomVideo {
    constructor() {
        this.roomId = false;

        this.$introVideo = $("#intro-video");
        this.$outroVideo = $("#outro-video");

        /** @type {import("video.js").VideoJsPlayer | null} */
        this.introVideo = null;

        /** @type {import("video.js").VideoJsPlayer | null} */
        this.outroVideo = null;
    }

    _setHasPlayed(roomId, videoBlock) {
        let states = Storage.get("states", {});
        const videoType = videoBlock === "intro" 
                ? "introVideo" 
                : "outroVideo";

        if (!states?.[videoType]) states[videoType] = [];

        if (!states[videoType].includes(roomId)) {
            states?.[videoType].push(roomId);
        }
        
        return Storage.set("states", states);
    }

    _getHasPlayed(roomId, videoBlock) {
        let states = Storage.get("states", {});
        const videoType = videoBlock === "intro" 
                ? "introVideo" 
                : "outroVideo";

        return states?.[videoType] 
        && states?.[videoType].includes(roomId);
    }

    init(roomId, videoBlock) {
        this.roomId = roomId;

        let self = this;

        // ======================== INTRO VIDEO ========================
        if (videoBlock === "intro") {
            if ($("#intro-video").length) {
                const videoUrl = $("#intro-video")
                    .find("source")
                    .attr("src");

                /**
                 * check wheiter the video has url or not
                 * if no url, close video popup and start room timer
                 **/
                if (videoUrl === "false") {
                    $("#intro-video").removeClass("is-open");
                    GameLogic.startRoomTimer();
                    return false;
                }

                // init video js with full screen
                this.introVideo = videojs("intro-video", {
                    controls: true,
                    autoplay: true,
                    preload: "auto",
                });

                // handle on ended video
                this.introVideo.on("ended", () => {
                    this.afterPlayIntroVideo();
                });

                // handle on error video
                this.introVideo.on("error", function () {
                    self.introVideo = null;
                });

                /**
                 * handle on seen video intro
                 * if the video is seen, start room timer
                 */
                if (this._getHasPlayed(roomId, "intro")) {
                    GameLogic.startRoomTimer();
                    return;
                }

                // handle if the video popup opened
                if ($("#intro-video").hasClass("is-open")) return;

                // open video popup
                this.showVideo(true);
            } else {
                GameLogic.startRoomTimer();
            }
        }

        // ======================== OUTRO VIDEO ========================
        if (videoBlock === "outro") {
            if ($("#outro-video").length) {
                const videoUrl = $("#outro-video")
                    .find("source")
                    .attr("src");

                /**
                 * check wheiter the video has url or not
                 * if no url, close video popup and start room timer
                 **/
                if (videoUrl === "false") {
                    $("#outro-video").removeClass("is-open");
                    // this.afterPlayOutroVideo();
                    return false;
                }

                // init video js with full screen
                this.outroVideo = videojs("outro-video", {
                    controls: true,
                    autoplay: true,
                    preload: "auto",
                });
                this.afterPlayOutroVideo();

                // handle on ended video
                this.outroVideo.on("ended", () => {
                    this.afterPlayOutroVideo();
                });

                // handle on error video
                this.outroVideo.on("error", function () {
                    self.outroVideo = null;
                });

                /**
                 * handle on seen video intro
                 * if the video is seen, start room timer
                 */
                if (this._getHasPlayed(roomId, "outro")) {
                    // this.afterPlayOutroVideo();
                    return;
                }

                // handle if the video popup opened
                if ($("#outro-video").hasClass("is-open")) return;

                // open video popup
                this.showVideo(false);
            }
        }
    }

    showVideo(isIntro) {
        if (isIntro) {
            $("#intro-video").addClass("is-open intro-video");
        } else {
            $("#outro-video").addClass("is-open outro-video");
        }
    }

    closeVideo(isIntro) {
        if(isIntro) {
            this.introVideo.dispose();
        } else {
            this.outroVideo.dispose();
        }
    }

    afterPlayIntroVideo() {
        $("#intro-video").removeClass("is-open");

        this.closeVideo(true);
        this._setHasPlayed(this.roomId, "intro");

        GameLogic.startRoomTimer();
    }

    afterPlayOutroVideo() {
        $("#outro-video").removeClass("is-open");

        this.closeVideo(false);
        this._setHasPlayed(this.roomId, "outro");
    }
}
